import { TYPESENSE_TOKEN_SEPARATOR } from 'src/constant';
import { crm_keys } from 'src/utils/crm-commons';
const unassignedUser = { value: TYPESENSE_TOKEN_SEPARATOR, label: 'Unassigned', id: TYPESENSE_TOKEN_SEPARATOR, fullName: 'Unassigned' };
const labelAllUsers = { id: 'all', fullName: 'All Users' };

// user = object, users = array, user_teams_ids = string array
export const buildPermissionToHomeSection = (user, users, user_teams_ids) => {
  const mapUsers = users.map(item => ({ id: item.id, fullName: `${item.firstname} ${item.lastname}`, firstname: item.firstname }));
  if(user.account_owner) {
    return [labelAllUsers, unassignedUser, ...mapUsers];
  }
  const { companies, contacts, leads, opportunities } = user.applied_permissions.crm;
  if(companies.view.type === 'ALL' || contacts.view.type === 'ALL' || leads.view.type === 'ALL' || opportunities.view.type === 'ALL') {
    if(companies.view.unassigned || contacts.view.unassigned || leads.view.unassigned || opportunities.view.unassigned) {
      return [labelAllUsers, unassignedUser, ...mapUsers];
    }
    return [labelAllUsers, ...mapUsers];
  }
  if(companies.view.type === 'THEIR TEAM OWNS' || contacts.view.type === 'THEIR TEAM OWNS' || leads.view.type === 'THEIR TEAM OWNS' || opportunities.view.type === 'THEIR TEAM OWNS') {
    const findUsers = [];
    for(const userID of user_teams_ids) {
      const find = mapUsers.find(item => item.id === userID);
      if(find) {
        findUsers.push(find);
      }
    }
    if(companies.view.unassigned || contacts.view.unassigned || leads.view.unassigned || opportunities.view.unassigned) {
      return [unassignedUser, ...findUsers];
    }
    return findUsers;
  }
  if(companies.view.type === 'THEY OWN' || contacts.view.type === 'THEY OWN' || leads.view.type === 'THEY OWN' || opportunities.view.type === 'THEY OWN') {
    if(companies.view.unassigned || contacts.view.unassigned || leads.view.unassigned || opportunities.view.unassigned) {
      return [unassignedUser, { id: user.id, fullName: `${user.firstname} ${user.lastname}`, firstname: user.firstname }];
    }
    return [{ id: user.id, fullName: `${user.firstname} ${user.lastname}`, firstname: user.firstname }];
  }
  return (companies.view.unassigned || contacts.view.unassigned || leads.view.unassigned || opportunities.view.unassigned) ? [unassignedUser] : [];
};

// permissions = object, user_id = string, users = array, user_teams_ids = string array
export const buildPermissionToOwnerTypesense = (permissions, user_id, users, user_teams_ids) => {
  const mapUsers = users.map(item => ({ value: item.id, label: `${item.firstname} ${item.lastname}` }));
  let sendUsers = [];
  if(permissions.type === 'NONE' && permissions.unassigned) {
    sendUsers = [unassignedUser];
  }
  if(permissions.type === 'ALL') {
    sendUsers = permissions.unassigned ? [unassignedUser, ...mapUsers] : mapUsers;
  }
  if(permissions.type === 'THEY OWN') {
    const findUser = mapUsers.find(item => item.value === user_id);
    sendUsers = permissions.unassigned ? [unassignedUser, findUser] : [findUser];
  }
  if(permissions.type === 'THEIR TEAM OWNS') {
    const findUsers = [];
    for(const userID of user_teams_ids) {
      const find = mapUsers.find(item => item.value === userID);
      if(find) {
        findUsers.push(find);
      }
    }
    sendUsers = permissions.unassigned ? [unassignedUser, ...findUsers] : findUsers;
  }
  return sendUsers;
};

// permissions = object, user_id = string, user_teams_ids = string array, all_users = string array
export const validPermissionToReadActivitiesTypesense = (permissions, user_id, user_teams_ids, all_users) => {
  const filterBy = [];
  for(const value of crm_keys) {
    const { type, unassigned } = permissions[value.pluralLowerCase].view;
    if(type === 'ALL') {
      for(const user of all_users) {
        filterBy.push(`${user.id}__${value.value}`);
      }
    }
    if(type === 'THEIR TEAM OWNS') {
      for(const user of user_teams_ids) {
        filterBy.push(`${user}__${value.value}`);
      }
    }
    if(type === 'THEY OWN') {
      filterBy.push(`${user_id}__${value.value}`);
    }
    if(unassigned) {
      filterBy.push(`${TYPESENSE_TOKEN_SEPARATOR}__${value.value}`);
    }
  }
  return filterBy.length ? `&&owner_id_record_type:=[${filterBy.join(',')}]` : 'ERROR';
};

// permissions = object, user_id = string, user_teams_ids = string array
export const validPermissionToReadTypesense = (permissions, user_id, user_teams_ids) => {
  let filterBy = '';
  if(permissions.type === 'NONE') {
    filterBy = permissions.unassigned ? `&&owner_id:=${TYPESENSE_TOKEN_SEPARATOR}` : 'ERROR';
  }
  if(permissions.type === 'ALL' && !permissions.unassigned) {
    filterBy = `&&owner_id:!=${TYPESENSE_TOKEN_SEPARATOR}`;
  }
  if(permissions.type === 'THEY OWN') {
    filterBy = `&&owner_id:=[${user_id}${permissions.unassigned ? `,${TYPESENSE_TOKEN_SEPARATOR}` : ''}]`;
  }
  if(permissions.type === 'THEIR TEAM OWNS') {
    filterBy = user_teams_ids.length ? `&&owner_id:=[${user_teams_ids.join(',')}${permissions.unassigned ? `,${TYPESENSE_TOKEN_SEPARATOR}` : ''}]` : permissions.unassigned ? `&&owner_id:=${TYPESENSE_TOKEN_SEPARATOR}` : 'ERROR';
  }
  return filterBy;
};

// permissionType = string, permissionUnassigned = boolean, user_id = string, owner_id = string, user_teams_ids = string array
export const validPermissionToReadCRM = (permissionType, permissionUnassigned, user_id, owner_id, user_teams_ids) => {
  let permissionToRead = true;
  if(permissionType === 'NONE') {
    permissionToRead = false;
    if(permissionUnassigned && TYPESENSE_TOKEN_SEPARATOR === owner_id) {
      permissionToRead = true;
    }
  }
  if(permissionType === 'ALL') {
    if(!permissionUnassigned && TYPESENSE_TOKEN_SEPARATOR === owner_id) {
      permissionToRead = false;
    }
  }
  if(permissionType === 'THEY OWN') {
    if(user_id !== owner_id) {
      permissionToRead = false;
    }
    if(permissionUnassigned && TYPESENSE_TOKEN_SEPARATOR === owner_id) {
      permissionToRead = true;
    }
  }
  if(permissionType === 'THEIR TEAM OWNS') {
    if(user_teams_ids.length) {
      if(!user_teams_ids.includes(owner_id)) {
        permissionToRead = false;
      }
    } else {
      permissionToRead = false;
    }
    if(permissionUnassigned && TYPESENSE_TOKEN_SEPARATOR === owner_id) {
      permissionToRead = true;
    }
  }
  return permissionToRead;
};

// permissionType = string, permissionUnassigned = boolean, user_id = string, owner_id = string, user_teams_ids = string array
export const validPermissionToUpdateCRM = (permissionType, permissionUnassigned, user_id, owner_id, user_teams_ids) => {
  let permissionToUpdate = true;
  if(permissionType === 'NONE') {
    permissionToUpdate = false;
    if(permissionUnassigned && TYPESENSE_TOKEN_SEPARATOR === owner_id) {
      permissionToUpdate = true;
    }
  }
  if(permissionType === 'ALL') {
    if(!permissionUnassigned && TYPESENSE_TOKEN_SEPARATOR === owner_id) {
      permissionToUpdate = false;
    }
  }
  if(permissionType === 'THEY OWN') {
    if(user_id !== owner_id) {
      permissionToUpdate = false;
    }
    if(permissionUnassigned && TYPESENSE_TOKEN_SEPARATOR === owner_id) {
      permissionToUpdate = true;
    }
  }
  if(permissionType === 'THEIR TEAM OWNS') {
    if(user_teams_ids.length) {
      if(!user_teams_ids.includes(owner_id)) {
        permissionToUpdate = false;
      }
    } else {
      permissionToUpdate = false;
    }
    if(permissionUnassigned && TYPESENSE_TOKEN_SEPARATOR === owner_id) {
      permissionToUpdate = true;
    }
  }
  return permissionToUpdate;
};

// permissionType = string, permissionUnassigned = boolean, user_id = string, owner_id = string, user_teams_ids = string array
export const validPermissionToDeleteCRM = (permissionType, permissionUnassigned, user_id, owner_id, user_teams_ids) => {
  let permissionToDelete = true;
  if(permissionType === 'NONE') {
    permissionToDelete = false;
    if(permissionUnassigned && TYPESENSE_TOKEN_SEPARATOR === owner_id) {
      permissionToDelete = true;
    }
  }
  if(permissionType === 'ALL') {
    if(!permissionUnassigned && TYPESENSE_TOKEN_SEPARATOR === owner_id) {
      permissionToDelete = false;
    }
  }
  if(permissionType === 'THEY OWN') {
    if(user_id !== owner_id) {
      permissionToDelete = false;
    }
    if(permissionUnassigned && TYPESENSE_TOKEN_SEPARATOR === owner_id) {
      permissionToDelete = true;
    }
  }
  if(permissionType === 'THEIR TEAM OWNS') {
    if(user_teams_ids.length) {
      if(!user_teams_ids.includes(owner_id)) {
        permissionToDelete = false;
      }
    } else {
      permissionToDelete = false;
    }
    if(permissionUnassigned && TYPESENSE_TOKEN_SEPARATOR === owner_id) {
      permissionToDelete = true;
    }
  }
  return permissionToDelete;
};

// permissionType = string, permissionUnassigned = boolean, user_id = string, owner_id = string, user_teams_ids = string array
export const validPermissionToReadWebfinder = (permissionType, user_id, owner_id, user_teams_ids) => {
  let permissionToRead = true;
  if(permissionType === 'NONE') {
    permissionToRead = false;
  }
  if(permissionType === 'THEY OWN' && user_id !== owner_id) {
    permissionToRead = false;
  }
  if(permissionType === 'THEIR TEAM OWNS') {
    if(user_teams_ids.length) {
      if(!user_teams_ids.includes(owner_id)) {
        permissionToRead = false;
      }
    } else {
      permissionToRead = false;
    }
  }
  return permissionToRead;
};
